module.exports = __webpack_public_path__ + "static/img/title.6c5a26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.jpg
// module id = XSUu
// module chunks = 0